import { Component } from '@angular/core';

@Component({
	selector: 'leads-report-page',
	templateUrl: './leads-report.page.html',
	styleUrls: ['./leads-report.page.scss']
})
export class LeadsReportPage {
}
